import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { transformDate } from "app/common/LocalFunction";
import moment from "moment";
import * as Yup from "yup";
import { Grid } from "@material-ui/core";
import EncounterDiagnosisForm from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/HistoryDiagnosis/Component/EncounterDiagnosisForm";
import FilterListIcon from "@material-ui/icons/FilterList";
import SearchCheckIn from "./Component/SearchCheckIn";
import ListCheckIn from "./Component/ListCheckIn";
const HistoryDiagnosisTabIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const defaultDepartment = useDefaultDepartment();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={6}>
        <CheckInDetail
          patientId={patientId}
          defaultDepartment={defaultDepartment}
        />
      </Grid>

      <Grid item xs={12} lg={6}>
        <EncounterDiagnosisForm patientId={patientId} />
      </Grid>
    </Grid>
  );
};

const CheckInDetail = observer(({ patientId, defaultDepartment }) => {
  const {
    searchCheckIn,
    handleChangeFormSearch,
    resetStore,
    openConfirmDeleteSingleImage,
    handleCloseConfirmSingleImage,
    handleDeleteSingleImage,
  } = useStore().patientManagementStore.encounterDiagnosisStore;
  let [isOpenFillter, setOpenFillter] = useState(true);

  useEffect(() => {
    if (patientId) {
      handleChangeFormSearch({
        ...searchCheckIn,
        patientId,
      });
    }
    return () => resetStore();
  }, [patientId, defaultDepartment]);

  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });
  return (
    <Formik
      initialValues={searchCheckIn}
      validationSchema={searchPatientValidationSchema}
      onSubmit={(values) => {
        handleChangeFormSearch(values);
      }}
      enableReinitialize
    >
      <Form autoComplete="off">
        <Grid item xs={12}>
          <div className="cards-header flex gap-2">
            <h4 style={{ fontSize: "16px" }}>Danh sách đến khám</h4>
            <span
              style={{ cursor: "pointer" }}
              className="flex items-center"
              onClick={() => setOpenFillter(!isOpenFillter)}
            >
              <FilterListIcon color="red" />
            </span>
          </div>
        </Grid>
        <SearchCheckIn isOpenFillter={isOpenFillter} />
        <ListCheckIn patientId={patientId} />

        <ConfirmPopup
          open={openConfirmDeleteSingleImage}
          onClose={handleCloseConfirmSingleImage}
          text={"Bạn có chắc chắn muốn xóa ảnh này?"}
          onConfirm={handleDeleteSingleImage}
        />
      </Form>
    </Formik>
  );
});

export default memo(observer(HistoryDiagnosisTabIndex));
